<template>
  <Modal
    :width="620"
    name="HAUSEFUL_INVOICE_LINK_PAYMENTS_MODAL"
    :title="$t('hausefulInvoices.modals.linkPayments.title')"
    actions
  >
    <template v-slot:body>
      <p class="body-2">
        {{ $t('hausefulInvoices.modals.linkPayments.message') }}
      </p>

      <v-card class="py-3 px-4 my-3" color="grey lighten-3" outlined>
        <h6 class="text-uppercase grey--text">
          {{ $t('hausefulInvoices.realEstate') }}
        </h6>
        <span class="body-2 d-block">
          {{ realEstateName }}
        </span>
        <span class="body-2 d-block success--text font-weight-bold mt-2">
          {{ $t('hausefulInvoices.modals.linkPayments.invoiceValue') }}: {{ invoiceValue }}
        </span>
      </v-card>

      <div v-if="isLoading" class="text-center py-4">
        <v-progress-circular indeterminate color="primary" size="28" />
      </div>

      <div v-else-if="!paymentLinkSuggestions.length" class="body-2 grey--text py-4">
        {{ $t('hausefulInvoices.modals.linkPayments.empty') }}
      </div>

      <v-radio-group v-else v-model="selectedGroup" class="mt-0">
        <v-radio
          v-for="(suggestion, index) in paymentLinkSuggestions"
          :key="index"
          :value="index"
          class="py-2"
        >
          <template v-slot:label>
            <div class="d-flex flex-column">
              <span class="body-2">
                {{ suggestion.period }}
                <v-chip
                  v-if="suggestion.matches_invoice_value"
                  color="success"
                  class="ml-2 caption"
                  x-small
                  outlined
                >
                  {{ $t('hausefulInvoices.modals.linkPayments.matches') }}
                </v-chip>
              </span>
              <span class="caption grey--text">
                {{ suggestion.payments_count }}
                {{ $t('hausefulInvoices.modals.linkPayments.payments') }} ·
                {{ formatMoney(suggestion.hauseful_value) }}
              </span>
            </div>
          </template>
        </v-radio>
      </v-radio-group>
    </template>

    <template v-slot:actions>
      <v-btn @click="closeAllModals" :disabled="isLoading" class="grey--text" elevation="0" text>
        {{ $t('hausefulInvoices.modals.defaultActions.cancel') }}
      </v-btn>
      <v-btn
        @click="link"
        :loading="isLoading"
        :disabled="selectedGroup === null"
        elevation="0"
        class="ml-5"
        color="primary"
      >
        {{ $t('hausefulInvoices.modals.linkPayments.action') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import Modal from '@/components/app/Modal'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'ModalHausefulInvoiceLinkPayments',

  components: {
    Modal,
  },

  data() {
    return {
      selectedGroup: null,
      formatMoney: catalogMonetary,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'hausefulInvoiceInfo', 'paymentLinkSuggestions']),

    realEstateName() {
      return this.hausefulInvoiceInfo?.real_estate?.name ?? '---'
    },

    invoiceValue() {
      return catalogMonetary(this.hausefulInvoiceInfo?.hauseful_value ?? 0.00)
    },
  },

  watch: {
    paymentLinkSuggestions(suggestions) {
      // Pré-seleciona a quinzena cujo total bate com o valor da nota
      const matching = suggestions.findIndex((suggestion) => suggestion.matches_invoice_value)
      this.selectedGroup = matching >= 0 ? matching : null
    },
  },

  methods: {
    ...mapActions(['linkHausefulInvoicePayments']),
    ...mapMutations(['closeAllModals']),

    link() {
      if (this.selectedGroup === null) return
      this.linkHausefulInvoicePayments({
        invoiceId: this.hausefulInvoiceInfo.id,
        paymentsIds: this.paymentLinkSuggestions[this.selectedGroup].payments_ids,
      })
    },
  },
}
</script>
